//@flow
import React, { Component } from 'react';

import ZoneMapsSidebar from './ZoneMapsSidebar';
import LeafletMapWithZones from 'common/components/core/leaflet/LeafletMapWithZones';
import ZoneMapSaveDialog from './ZoneMapSaveDialog';
import MapBulkVerifyConfirmationDialog from './MapBulkVerifyConfirmationDialog';

import { Loader } from 'common/components/core/loader/Loader';
import theme from './ZoneMapEditView.scss';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { SlideInFromLeft } from 'common/components/core/animations';
import { ConfirmationDialog } from 'common/components/core/dialog/ConfirmationDialog';
import { translate } from 'react-i18next';

class ZoneMapEditView extends Component {
    state = {
        isExpanded: true
    };

    onCollapseSidebar = callback =>
        this.setState({ isExpanded: false }, () => setTimeout(callback, 200));
    onExpandSidebar = callback =>
        this.setState({ isExpanded: true }, () => setTimeout(callback, 200));

    handleZoneMapSave = () => {
        const { zoneMap, handleZoneMapSave } = this.props;
        zoneMap && handleZoneMapSave({ map: zoneMap });
    };

    render() {
        const {
            t,
            clientId,
            zoneMap,
            isMapModified,
            isMapVerified,
            isMapToBeVerified,
            isInvalidZoneDialogActive,
            isMapVerifyDialogActive,
            bounds,
            selectedZoneId,
            selectedGroupId,
            hoveredGeometryIds,
            hoveredGroupId,
            handleMapNameSave,
            handlePlaceSearch,
            handleEntityCardClick,
            handleFolderCardClick,
            handleMapVerifyToggle,
            handleFolderVerifyToggle,
            handleZoneVerifyToggle,
            handleZoneVisibilityToggle,
            handleFolderVisibilityToggle,
            handleZoneClick,
            handleFolderNameUpdate,
            handlePopupClose,
            handleFolderDelete,
            onUpdateGeometry,
            setLayerRef,
            createZone,
            handleZoneDelete,
            setGeometries,
            handleAddFolder,
            pincodes,
            colors,
            isMapLoading,
            canVerify,
            handleBackClick,
            handleBackSave,
            handleBackCancel,
            handleBackConfirm,
            handleGeometryHover,
            handleGeometryCardHover,
            resetHoveredGeometries,
            handleFolderCardHover,
            handleFolderCardBlur,
            namedZones,
            ungroupZone,
            handleReorderZone,
            toggleLabels,
            setInvalidZoneDialogInactive,
            setMapVerifyDialogInactive,
            resetActiveZone,
            mapCenter,
            resetActiveGroup,
            layerRefs,
            homebase,
            availableRiders,
            defaultCountryCenter,
            mapMetadataSettings
        } = this.props;

        const { isExpanded } = this.state;
        const {
            id,
            folders,
            name: mapName,
            geometries,
            teamId: { teamId } = {}
        } = zoneMap || {};
        const whiteListedPathnames = [`/client/${clientId}/entity/map/${id}`];
        const modified = isMapModified || isMapToBeVerified;
        return (
            <div className={theme.leafletWrap}>
                {isMapLoading ? <Loader active theme={theme} /> : null}
                <CSSTransitionGroup
                    className={theme.sidebarWrap}
                    transitionName={SlideInFromLeft}
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={200}
                >
                    {zoneMap && isExpanded ? (
                        <ZoneMapsSidebar
                            mapName={mapName}
                            isMapModified={modified}
                            isMapVerified={isMapVerified}
                            isVerifyHidden={!canVerify}
                            isVerifyDisabled={!canVerify}
                            geometries={geometries}
                            folders={folders}
                            handleMapNameSave={handleMapNameSave}
                            handleZoneMapSave={this.handleZoneMapSave}
                            handleEntityCardClick={handleEntityCardClick}
                            handleFolderCardClick={handleFolderCardClick}
                            handleMapVerifyToggle={handleMapVerifyToggle}
                            handleZoneVerifyToggle={handleZoneVerifyToggle}
                            handleZoneVisibilityToggle={
                                handleZoneVisibilityToggle
                            }
                            handleFolderVisibilityToggle={
                                handleFolderVisibilityToggle
                            }
                            handleFolderVerifyToggle={handleFolderVerifyToggle}
                            selectedZoneId={selectedZoneId}
                            selectedGroupId={selectedGroupId}
                            hoveredGeometryIds={hoveredGeometryIds}
                            hoveredGroupId={hoveredGroupId}
                            handleAddFolder={handleAddFolder}
                            handleFolderNameUpdate={handleFolderNameUpdate}
                            handleFolderDelete={handleFolderDelete}
                            onBack={handleBackClick}
                            handleGeometryCardHover={handleGeometryCardHover}
                            resetHoveredGeometries={resetHoveredGeometries}
                            handleFolderCardHover={handleFolderCardHover}
                            handleFolderCardBlur={handleFolderCardBlur}
                            namedZones={namedZones}
                            handleZoneDelete={handleZoneDelete}
                            ungroupZone={ungroupZone}
                            handleReorderZone={handleReorderZone}
                            toggleLabels={toggleLabels}
                        />
                    ) : null}
                </CSSTransitionGroup>
                {zoneMap ? (
                    <LeafletMapWithZones
                        layerRefs={layerRefs}
                        teamId={teamId}
                        mapName={mapName}
                        isExpanded={isExpanded}
                        bounds={bounds}
                        folders={folders}
                        pincodes={pincodes}
                        colors={colors}
                        geometries={geometries}
                        selectedZoneId={selectedZoneId}
                        hoveredGeometryIds={hoveredGeometryIds}
                        handleZoneClick={handleZoneClick}
                        handleGeometryHover={handleGeometryHover}
                        resetHoveredGeometries={resetHoveredGeometries}
                        setLayerRef={setLayerRef}
                        createZone={createZone}
                        handleZoneDelete={handleZoneDelete}
                        setGeometries={setGeometries}
                        handlePlaceSearch={handlePlaceSearch}
                        onUpdateGeometry={onUpdateGeometry}
                        handlePopupClose={handlePopupClose}
                        mapCenter={mapCenter}
                        namedZones={namedZones}
                        onExpandSidebar={this.onExpandSidebar}
                        onCollapseSidebar={this.onCollapseSidebar}
                        resetActiveZone={resetActiveZone}
                        resetActiveGroup={resetActiveGroup}
                        homebase={homebase}
                        availableRiders={availableRiders}
                        defaultCountryCenter={defaultCountryCenter}
                        clientId={clientId}
                        mapMetadataSettings={mapMetadataSettings}
                    />
                ) : null}
                <ZoneMapSaveDialog
                    mapName={mapName}
                    when={isMapModified && !isMapLoading}
                    whiteListedPathnames={whiteListedPathnames}
                    searchQueryCheck={!id}
                    isMapLoading={isMapLoading}
                    onBack={handleBackClick}
                    onCancel={handleBackCancel}
                    onConfirm={handleBackConfirm}
                    onSave={handleBackSave}
                    handleMapNameSave={handleMapNameSave}
                />
                {isInvalidZoneDialogActive ? (
                    <ConfirmationDialog
                        title={t('zoneMap.invalidZone')}
                        theme={theme}
                        onAccept={setInvalidZoneDialogInactive}
                        onCancel={setInvalidZoneDialogInactive}
                        active
                        innerText={t('zoneMap.invalidZoneMessage')}
                        acceptActionLabel={t('zoneMap.dismiss')}
                    />
                ) : null}
                {isMapVerifyDialogActive ? (
                    <MapBulkVerifyConfirmationDialog
                        type={t('zoneMap.map')}
                        theme={theme}
                        active
                        onAccept={handleMapVerifyToggle}
                        onCancel={setMapVerifyDialogInactive}
                        isVerified={isMapVerified}
                    />
                ) : null}
            </div>
        );
    }
}

export default translate('entityManagement')(ZoneMapEditView);
